import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
type ManagerReportServicePayload = {
  startDate: string
  endDate: string
}

export async function getManagerReportService(
  payload: ManagerReportServicePayload,
) {
  const repsonse = await api.get<ResponseAPI>(
    `/gerencial/${payload.startDate}/${payload.endDate}`,
  )

  return repsonse.data.body
}
